import axios from '@/libs/api.request'

export const getAssembledPartCosts = (data) => {
  return axios.request({
    url: `part-costs`,
    method: 'get',
    params: data
  })
}

export const getAssembledPartCostById = (id) => {
  return axios.request({
    url: `part-costs/${id}`,
    method: 'get'
  })
}

export const updateAssembledPartCost = (id, data) => {
  return axios.request({
    url: `part-costs/${id}`,
    method: 'put',
    data
  })
}

export const updateAssembledPartCostSetBom = (id, data) => {
  return axios.request({
    url: `part-costs/${id}/set-bom`,
    method: 'put',
    data
  })
}

export const createAssembledPartCost = (data) => {
  return axios.request({
    url: `part-costs`,
    method: 'post',
    data
  })
}

export const deleteAssembledPartCost = (id) => {
  return axios.request({
    url: `part-costs/${id}`,
    method: 'delete'
  })
}

export const getAssembledPartCostSummaries = (assembledPartCostId) => {
  return axios.request({
    url: `part-costs/${assembledPartCostId}/summaries`,
    method: 'get'
  })
}

export const initialAssembledPartCostMaterialCosts = (id) => {
  return axios.request({
    url: `part-costs/${id}/initial-material-costs`,
    method: 'post'
  })
}

export const getLineItemsByType = (partCostId, type) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${type}`,
    method: 'get'
  })
}

export const saveLineItem = (partCostId, type, data) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${type}`,
    method: 'post',
    data
  })
}

export const saveMultipleLineItems = (partCostId, type, items, automaticPricing = true) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${type}/batch`,
    method: 'post',
    data: {
      items,
      automatic_pricing: automaticPricing
    }
  })
}

export const updateLineItem = (partCostId, id, data) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${data.line_item_type}/${id}`,
    method: 'put',
    data: data
  })
}
export const updateMaterialsLineItem = (partCostId, id, data) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/material/${id}/change-price`,
    method: 'put',
    data: data
  })
}
export const deleteLineItem = (partCostId, type, id) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${type}/${id}}`,
    method: 'delete'
  })
}

export const getMaterialLineItemChangeLog = (partCostId, type, id) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${type}/${id}}/change-logs`,
    method: 'get'
  })
}

export const deleteLineItemList = (partCostId, type) => {
  return axios.request({
    url: `part-costs/${partCostId}/items/${type}`,
    method: 'delete'
  })
}

export const generatePricingOverviewSummary = (scope) => {
  return axios.request({
    url: `cost-stats/generate/${scope}`,
    method: 'post'
  })
}

export const getPricingOverviewSummary = (scope) => {
  return axios.request({
    url: `cost-stats?name=summary&scope=${scope}`,
    method: 'get'
  })
}

export const getQuantityRelated = (id) => {
  return axios.request({
    url: `part-costs/${id}/related`,
    method: 'get'
  })
}

export const getStdCost = (id) => {
  return axios.request({
    url: `part-costs/${id}/refresh-costs`,
    method: 'post'
  })
}

export const getCostedBOMParts = (costEstimatorId) => {
  return axios.request({
    url: `cost-estimators/${costEstimatorId}/costed-bom`,
    method: 'get'
  })
}

export const getCostedBOMReport = (costEstimatorId, reports, assembled_part_cost_id = null) => {
  return axios.request({
    url: `cost-estimators/${costEstimatorId}/report`,
    method: 'get',
    params: { reports, assembled_part_cost_id }
  })
}

export const getCostEstimatorInfo = (costEstimatorId) => {
  return axios.request({
    url: `cost-estimators/${costEstimatorId}`,
    method: 'get'
  })
}

export const getCostedBomSummary = (costEstimatorId) => {
  return axios.request({
    url: `cost-estimators/${costEstimatorId}/summary`,
    method: 'get'
  })
}

// export const getPartCostsReport = (costId, reports, assembled_part_cost_id) => {
//   return axios.request({
//     url: `part-costs/${costId}/report`,
//     method: 'get',
//     params: { reports, assembled_part_cost_id }
//   })
// }

export const getPartCostsParts = (costId) => {
  return axios.request({
    url: `part-costs/${costId}/costed-bom`,
    method: 'get'
  })
}

export const getModifyPriceReasons = () => {
  return axios.request({
    url: `part-costs/price-adjustment-reasons`,
    method: 'get'
  })
}

export const addSupplierQuote = (costId, lineItemId, data) => {
  return axios.request({
    url: `pricing/${costId}/items/${lineItemId}/create-rfq-price`,
    method: 'post',
    data
  })
}
